// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"1721adca","279":"bebb9594","374":"865294fc","381":"65acb1d9","641":"0a21eaf5","782":"4d352d1c","894":"63196fe9"}[chunkId] + ".chunk.js";
};